import { Card, Tooltip } from "antd";
import React, { useState } from "react";
import Utils from "../../utils/Utils";
import { Link } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";
import Icon from "../../../assets/Icon";

function FruadSSDisplay({
  config,
  interviewAnalysisIntegrityData,
  updateVideoTrack,
}) {
  // console.log(interviewAnalysisIntegrityData);
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleImageClick = (src) => {
    setEnlargedImage(src);
  };

  const closeModal = () => {
    setEnlargedImage(null);
  };
  return (
    <div>
      <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]">
        <p className="text-[#475467] text-lg font-semibold pb-2 flex items-center gap-3">
          Out-of-window occurrences:{"  "}
          <Tooltip title="Out-of-window occurrences / Total chances given">
            <span className="text-orange-400">
              {interviewAnalysisIntegrityData?.fraudOccurrenceChancesGiven -
                interviewAnalysisIntegrityData?.fraudOccurrenceChancesLeft}
              /{interviewAnalysisIntegrityData?.fraudOccurrenceChancesGiven}
            </span>
          </Tooltip>
        </p>
        {config?.screenRecordingRequired ? (
          <>
            <div className="snapshot-container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 rounded-md">
              {interviewAnalysisIntegrityData?.fraudulentSnapshotData?.length >
                0 &&
                interviewAnalysisIntegrityData.fraudulentSnapshotData.map(
                  (item, i) => (
                    <div key={i} className="flex flex-col items-center">
                      <img
                        src={item?.snapshotUrl}
                        alt=""
                        className="rounded-md cursor-pointer hover:scale-110 transition-all duration-200 ease-in-out"
                        onClick={() => handleImageClick(item?.snapshotUrl)}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                      {item?.timestamp && (
                        <p className="text-sm text-start w-full  mt-1">
                          <span
                            onClick={(e) => {
                              updateVideoTrack(item.timestamp);
                              window.scrollTo({
                                top: 200,
                                behavior: "smooth",
                              });
                            }}
                            className="cursor-pointer text-blue-500 border-b-2 border-blue-400 font-medium"
                          >
                            {Utils.convertSecondsToTime(item.timestamp)}
                          </span>
                        </p>
                      )}
                    </div>
                  ),
                )}
            </div>
            <div className="mt-2 text-red-500">
              <strong>Note:</strong> This indicates the total number of times
              the candidate moved out of the interview window. A higher count
              results in a lower integrity.
            </div>
          </>
        ) : (
          <div className="mt-2 mx-auto">
            <p className="text-center flex justify-center">
              <Icon type="lock-orientation-icon" width="46" height="46" />
            </p>
            <p className=" text-[#475467] text-center mt-2 text-[.95rem]">
              Upgrade/Enable to unlock all screen recording premium features.
            </p>
          </div>
        )}

        {enlargedImage && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
            onClick={closeModal}
          >
            <img
              src={enlargedImage}
              alt="Enlarged"
              className="max-w-full max-h-full rounded-md"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              className="absolute top-4 right-4 text-white text-2xl"
              onClick={closeModal}
            >
              &times;
            </button>
          </div>
        )}
      </Card>
      <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]  w-full ">
        <div className="flex md:flex-row flex-col justify-between gap-6 w-full">
          <div className="w-full">
            <Card className=" w-full h-full">
              <div className="w-full text-[#475467] font-semibold pb-2 flex items-center  flex-col  gap-3">
                <div className="text-xl text-center">
                  Interview Join Attempts{" "}
                  <Tooltip
                    title={
                      <div>
                        <p>
                          Number of joining attempts where candidate joined and
                          continued for more than a minute.
                        </p>
                      </div>
                    }
                  >
                    <QuestionCircleOutlined className=" cursor-pointer" />
                  </Tooltip>
                </div>
                {"  "}
                <div className="text-orange-400 text-6xl leading-10">
                  {interviewAnalysisIntegrityData?.totalInterviewRejoins <= 0
                    ? "NA"
                    : interviewAnalysisIntegrityData?.totalInterviewRejoins}
                </div>
              </div>
            </Card>
            <div className="text-red-500 md:w-1/2 pl-1 md:hidden block mt-1">
              <p>
                <strong>Note: </strong>
                Number of joining attempts where candidate joined and continued
                for more than a minute.
              </p>
              <p>
                <strong>Tip: </strong>
                Anything greater 1 will have less integrity. Higher the
                score lesser the integrity.
              </p>
            </div>
          </div>
          <div className="w-full">
            <Card className=" w-full text-[#475467] h-full">
              <div className="font-semibold flex gap-2 justify-center items-center text-xl">
                IP Address List{"  "}
                <Tooltip
                  title={
                    <div>
                      <p>
                        Total number of IP Addresses identified during the
                        interview process.
                      </p>
                    </div>
                  }
                >
                  <QuestionCircleOutlined className=" cursor-pointer" />
                </Tooltip>
              </div>
              <div className="flex flex-col items-center  mt-1 max-h-[88px] text-xl scroll overflow-auto">
                {interviewAnalysisIntegrityData?.uniqueIpAddresses?.map(
                  (items, index) => (
                    <p key={index} className="text-blue-500 font-semibold">
                      {items}
                    </p>
                  ),
                )}
              </div>
            </Card>
            <div className="text-red-500 md:w-1/2 pl-1 md:hidden block mt-1">
              <p>
                <strong>Note: </strong>
                Total number of IP Addresses identified during the interview
                process.
              </p>
              <p>
                <strong>Tip: </strong>
                Anything greater than 1 will have less integrity. Higher
                the number of unique IPs, lesser the integrity.
              </p>
            </div>
          </div>
        </div>
        <div className="md:flex hidden md:flex-row flex-col  gap-6 mt-1">
          <div className="text-red-500 md:w-1/2 pl-1">
            <p>
              <strong>Note: </strong>
              Number of joining attempts where candidate joined and continued
              for more than a minute.
            </p>
            <p>
              <strong>Tip: </strong>
              Anything greater 1 will have less integrity. Higher the
              score lesser the integrity.
            </p>
          </div>
          <div className="text-red-500 md:w-1/2 pl-1">
            <p>
              <strong>Note: </strong>Total number of IP Addresses identified
              during the interview process.
            </p>
            <p>
              <strong>Tip: </strong>
              Anything greater than 1 will have less integrity. Higher the
              number of unique IPs, lesser the integrity.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default FruadSSDisplay;
